
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import AppPanel from '../fw/AppPanel.react';

import types from '../../common/model-api/types';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import {wrapNotFound} from "../app/NotFoundHandler.react";
import FlowSimpleList from './FlowSimpleList.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'flowList.title', 'defaultMessage': 'Flows'},
});

interface FlowListProps {
    intl: IntlShape;
    relay?: object;
    user: User;
}

class FlowList extends React.Component<FlowListProps> {

    typeName = 'flows';

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object,
        user: PropTypes.object.isRequired
    };

    constructor() {
        super();
    }

    render() {
        return (
            <AppPanel  breadcrumbParams={[
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={this.props.intl.formatMessage(messages.title)}>
                <FlowSimpleList organisation={this.props.user.organisation} />
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(FlowList), (props) => {
    return props.user.organisation;
}), {
    initialVariables: {
        first: 200,
        after: null,
        organisationId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    ${FlowSimpleList.getFragment('organisation')}
                }
            }
        `,
    },
});
